import React from 'react';
export function Footer() {
  return <footer className="bg-navy-deep px-5 pb-32 pt-10 text-center text-white/60" data-id="element-124" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl space-y-3 text-sm leading-relaxed" data-id="element-125" data-mp="3gg11ma61ua0t">
        <p data-id="element-126" data-mp="32oni2w855c5s">
          <span className="font-black text-white" data-id="element-127" data-mp="32ovuyo49khgz">AAC CLINICAL BLUEPRINT™</span> Educational resources for AAC planning and communication support.
        </p>
        <p data-id="element-128" data-mp="3uf0opddwyguv">© 2026 AAC Clinical Blueprint™. All rights reserved.</p>
        <p className="text-xs" data-id="element-129" data-mp="3uftmvpyt3y1e">
          This product is educational in nature and does not replace individualized assessment, professional judgment, specialist training, or applicable professional standards.
        </p>
      </div>
    </footer>;
}